import { useMutate } from "../../../core/hooks/useMutate";

export function useUpdateIlome(ceremonyId: number) {
    return useMutate(`ceremonies/${ceremonyId}/ilome`, "PATCH");
}
